import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { CONFIRM_BUTTON } from '@pages/EndInstruction/focuskey';
import constate from 'constate';
import { useNavigate } from 'react-router-dom';

const useEndInstruction = () => {
  const { setFocus } = useFocusable();

  const setButtonFocus = () => {
    setFocus(CONFIRM_BUTTON);
  };

  const navigate = useNavigate();

  const goMain = () => {
    navigate('/', { replace: true });
  };

  return { setButtonFocus, goMain };
};

export const [EndInstructionProvider, useEndInstructionContext] =
  constate(useEndInstruction);
